import { makeStyles } from "@material-ui/core";

export const bgInputs = "#F5F8F9";

export default makeStyles((theme) => ({
	relatedModelsContainer: {
		margin: "0 auto",
		maxWidth: "1296px",
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
	},
	title: {
		padding: "16px 32px",
		fontSize: "18px",
		fontWeight: 600,
		lineHeight: "1.33",
		letterSpacing: "0.15px",
		color: theme.palette.enabledHeader.main,
		textTransform: "uppercase",
	},
	modelsBlock: {
		display: "flex",
		justifyContent: "start",
		gap: "75px",
		padding: "24px 32px",
		overflowX: "auto",
	},
	inputRoot: {
		width: "300px",
		border: "none",
		margin: "16px",
		display: "flex",
		"& .MuiInputBase-root": {
			height: "48px",
		},
		"& .MuiOutlinedInput-inputAdornedStart": {
			paddingLeft: "16px",
		},
	},
	endAdornment: {
		top: "14px",
	},
	modelBlock: {
		display: "flex",
		minHeight: "60vh",
		flexDirection: "column",
		width: "100%",
		alignItems: "baseline",
	},
	innerWrap: {
		maxWidth: "1634px",
		flexWrap: "wrap",
		display: "flex",
		justifyContent: "left",
		marginBottom: "92px",
		gap: "24px",
	},
	modelCountInfo: {
		color: theme.palette.tableText.main,
		fontSize: "16px",
		fontWeight: "lighter",
		lineHeight: "1",
		letterSpacing: "0.4px",
	},
	messageNotFound: {
		alignSelf: "center",
		margin: "24px 0",
	},
	btn: {
		display: "flex",
		cursor: "pointer",
		position: "absolute",
		gap: "10px",
		top: "3%",
		right: "3%",
	},
	modelCard: {
		display: "inline-block",
		position: "relative",
		maxWidth: "280px",
		paddingBottom: "10px",
		minHeight: "332px",
		flexGrow: 0,
		borderRadius: "4px",
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
		backgroundColor: theme.palette.secondary.main,
		color: theme.palette.mainText.main,
		cursor: "pointer",
		textDecoration: "none",
		transition: "box-shadow 0.3s",
		"&:hover": {
			boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.08)",
			"& $iconHidden": {
				visibility: "visible",
			},
		},
	},
	shortCard: {
		height: "100%",
	},
	cardContent: {
		padding: "0 24px",
		textAlign: "initial",
		marginTop: "13px",
	},
	icon: {
		display: "inline-block",
	},
	iconHidden: {
		visibility: "hidden",
	},
	iconBlue: {
		color: "#367bf5",
	},
	modelDetailsPage: {
		backgroundColor: "linear-gradient(to bottom, #fbf8f5 0%, #fff 100%)",
		paddingBottom: 24,
		color: "#212121",
	},
	modelDetailsContainer: {
		maxWidth: "1296px",
		marginBottom: "24px",
		margin: "0 auto",
		backgroundColor: theme.palette.secondary.main,
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
		paddingBottom: "40px",
		"& blockquote": {
			borderLeft: "2px solid #ccc",
			margin: "0px",
			paddingLeft: "11px",
		},
	},
	modelDetailsHeading: {
		"&::before": {
			content: "''",
			position: "absolute",
			height: "100%",
			width: "100%",
			top: "0",
			left: "0",
			backgroundColor: "rgba(255, 255, 255, 0.8)",
			backdropFilter: "blur(20px)",
			zIndex: "-1",
		},
		width: "100%",
		backdropFilter: "blur(20px)",
		filter: "blur()",
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		padding: "24px 24px 24px 32px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: "70px",
	},
	modelName: {
		marginTop: "8px",
		fontSize: "32px",
		fontWeight: "normal",
		lineHeight: "36px",
	},
	modelText: {
		letterSpacing: "0.15px",
		fontSize: "20px",
		marginBottom: "25px",
	},
	flex: {
		display: "flex",
		gap: "12px",
		cursor: "default",
	},
	removeIcon: {
		position: "absolute",
		top: "-14px",
		right: "-14px",
		cursor: "pointer",
	},
	iconName: {
		color: theme.palette.tableText.main,
		fontSize: "18px",
	},
	iconList: {
		color: "#5e6e7d",
		fontSize: "18px",
		fontWeight: "normal",
		margin: "0",
		paddingLeft: "0",
		listStyle: "none",
	},
	iconFavorite: {
		position: "absolute",
		top: "16px",
		right: "16px",
		width: "32px",
		height: "32px",
		cursor: "pointer",
	},
	articleTitle: {
		fontSize: "24px",
		fontWeight: "bolder",
	},
	articleText: {
		fontSize: "18px",
	},
	list: {
		"& li": {
			listStyle: "disc",
			marginLeft: "18px",
		},
	},
	favoritesFilter: {
		color: theme.palette.tableText.main,
		fontSize: "20px",
		marginRight: "12px",
	},
	favIcon: {
		color: "#367BF5",
	},
	badge: {
		"& .MuiBadge-badge": {
			border: "1px solid #367BF5",
			minWidth: "14px",
			width: "16px",
			height: "16px",
			fontSize: "10px",
		},
	},
	compareCountBadge: {
		"& .MuiBadge-badge": {
			minWidth: "14px",
			width: "16px",
			height: "16px",
			fontSize: "10px",
		},
	},
	compareInactiveCountBadge: {
		"& .MuiBadge-badge": {
			backgroundColor: "#969392",
			color: "white",
		},
	},
	input: {
		minHeight: "48px",
		zIndex: 1,
		width: "200px",

		"& fieldset": {
			border: "1px solid #96939287",
		},
		"&.Mui-focused fieldset": {
			borderWidth: "1px !important",
		},
		"& .MuiAutocomplete-input": {
			minWidth: "0",
		},
	},
	inputFocus: {
		border: "none",
	},
	optionsRoot: {
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
		borderRadius: "4px",
		margin: "6px 0",
		backgroundColor: theme.palette.secondary.main,
		width: "200px",
		zIndex: 1202,
		"& .MuiAutocomplete-option[aria-selected=true]": {
			backgroundColor: "rgba(126, 166, 180, 0.15)",
		},
	},
	wraplinkToAgreement: {
		display: "flex",
		alignItems: "center",
		gap: "8px",
		cursor: "pointer",
	},
	linkToAgreement: {
		color: "#367bf5",
		fontSize: "16px",
		fontWeight: 600,
	},
	sideDrawer: {
		zIndex: 1210,
		position: "fixed",
		top: "0",
		bottom: 0,
		right: "0",
		width: "46%",
		backgroundColor: "white",
		height: "100vh",
		boxShadow: "0 6px 10px 0 rgb(0 0 0 / 8%)",
		overflowX: "hidden",
		overflowY: "scroll",
	},
	sideDrawerHidden: {
		transform: "translateX(100%)",
	},
	publicAgreementProduct: {
		fontSize: "18px",
		fontWeight: 600,
		color: "#5e6e7d",
		textTransform: "uppercase",
	},
	publicAgreementSummary: {
		marginBottom: "32px",
		color: "#212121",
		fontSize: "14px",
		letterSpacing: "0.15px",
		wordBreak: "break-word",
		"& blockquote": {
			borderLeft: "2px solid #ccc",
			margin: "0px",
			paddingLeft: "11px",
		},
	},
	publicAgreementNaming: {
		padding: "4px 0",
		color: "#5e6e7d",
		fontSize: "12px",
		letterSpacing: "0.4px",
	},
	drawerFlexContainer: {
		flexBasis: "48%",
		marginBottom: "32px",
	},
	sourceURL: {
		color: "#367BF5",
		letterSpacing: "0.15px",
		fontSize: "16px",
		fontWeight: 700,
		maxWidth: "80%",
		textDecoration: "none",
	},
	publicAgreementData: {
		letterSpacing: "0.15px",
		fontSize: "16px",
		color: "rgba(0, 0, 0, 0.87)",
	},
	drawerFilterLink: {
		color: "#367BF5",
		fontSize: "16px",
		cursor: "pointer",
	},
	manufacturersBlock: {
		display: "flex",
		flexWrap: "wrap",
		gap: 4,
	},
	flagsBlock: { display: "flex", alignItems: "center", gap: 8 },
	faviconImg: {
		height: 20,
		marginRight: 8,
	},
	dFlex: {
		display: "flex",
	},
	brokenUrl: {
		display: "none",
	},
	imageBlock: {
		gap: "16px",
		marginTop: "8px",
		marginBottom: "16px",
		alignItems: "start",
	},
	siteFavicon: {
		width: "20px",
		objectFit: "contain",
	},
	unfurlUrlHeader: {
		display: "flex",
		marginBottom: "5px",
		gap: "8px",
	},
	siteImage: {
		maxWidth: "140px",
		objectFit: "contain",
	},
	domainName: {
		fontWeight: 600,
		fontSize: 16,
	},
	tadi: {
		marginBottom: "44px",
	},
	tadiTitle: {
		display: "flex",
		alignItems: "center",
		fontSize: "12px",
		lineHeight: 1.33,
		color: theme.palette.text.secondary,
		marginBottom: "4px",
	},
	tadiRow: {
		display: "flex",
		alignItems: "center",
		fontSize: "16px",
		letterSpacing: "0.15px",
		overflow: "hidden",
		whiteSpace: "nowrap",
		paddingTop: "8px",
	},
	tadiRowTypography: {
		overflow: "hidden",
		maxWidth: 350,
		fontSize: "16px",
	},
	tadiRowDot: {
		color: theme.palette.primary.main,
		padding: "0 8px",
		fontSize: "12px",
	},
	tadiHeadDot: {
		padding: "0 8px",
		fontSize: "10px",
	},
	search: {
		backgroundColor: bgInputs,
		height: "40px",
		minWidth: "270px",
		borderRadius: "4px",
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: bgInputs,
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: theme.palette.primary.main,
		},
	},
	comparisonLayout: {
		minWidth: "1100px",
		margin: "24px auto",
		backgroundColor: theme.palette.secondary.main,
		padding: " 24px 7.5px 40px 9px",
		borderRadius: "4px",
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
	},
	table: {
		borderCollapse: "collapse",
		"& td": {
			border: `1px solid ${theme.palette.tableDivider.main}`,
			padding: "16px",
			width: "275px",
		},
		"& th": {
			border: `1px solid ${theme.palette.tableDivider.main}`,
			textAlign: "initial",
			minWidth: "174px",
			padding: "15px 12px",
			height: "48px",
		},
		"& tbody": {
			verticalAlign: "baseline",
		},
	},
	modelRow: {
		"& th, td": {
			border: "none",
			position: "relative",
			verticalAlign: "middle",
			padding: "16px 8px",
			height: "278px",
		},
	},
	modelButton: {
		cursor: "pointer",
		"&:hover": {
			boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.08)",
		},
	},
	modelSelectDialog: {
		borderTop: "1px solid #cddcdc",
	},
	modelSelectPanel: {
		borderBottom: "1px solid #cddcdc",
	},
	selectionBottomDrawer: {
		boxShadow: "0 0 0.5rem 0 rgba(0, 0, 0, 0.08)",
		backgroundColor: "#fff",
	},
	navlinTableContainer: {
		marginBottom: "32px",
		width: "100%",
	},
	navlinHeader: {
		position: "relative",
		zIndex: 3,
		fontSize: "12px",
		lineHeight: 1.33,
		color: theme.palette.text.secondary,
		display: "flex",
		gap: "10px",
		alignItems: "center",
	},
	navlinDivider: {
		width: "1px",
		backgroundColor: theme.palette.text.secondary,
		height: "16px",
	},
	navlinTable: {
		padding: "16px",
		width: "100%",
		borderRadius: "4px",
		overflow: "hidden",
		backgroundColor: theme.palette.inputTableDivider.main,
	},
	navlinImage: {
		height: "14px",
	},
	waveAnimation: {
		position: "absolute",
		top: 0,
		left: "-150%",
		height: "100%",
		width: "150%",
		background: `linear-gradient(
			  90deg,
			  transparent,
#ffffffa1,
			  transparent
			)`,
		animation: "$waveAnimation 1.6s linear infinite",
	},
	"@keyframes waveAnimation": {
		"0%": {
			left: "-150%",
		},
		"100%": {
			left: "100%",
		},
	},

	flexSpaceBetween: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: "16px",
	},
	seeMoreButton: {
		padding: "10px",
	},
	infoIcon: {
		marginLeft: "4px",
		verticalAlign: "middle",
		width: "16px",
		color: "#367bf5",
	},
	renegotiationDot: {
		padding: "0 8px",
		fontSize: "12px",
	},
	priceTextField: {
		"& .MuiOutlinedInput-root": {
			height: "28px",
			borderRadius: "4px",
			backgroundColor: "white",
			"& .MuiAutocomplete-input": {
				padding: 0,
				paddingLeft: 8,
			},
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "#CDDCDC",
		},
		"& .MuiOutlinedInput-input": {
			fontSize: "14px",
			padding: 0,
			color: "#367bf5",
			fontWeight: 600,
		},
	},
	autocompleteOption: {
		paddingRight: "16px",
		paddingLeft: "16px",
		fontSize: "14px",
	},
	autocompleteGroup: {
		paddingBottom: "6px",
		fontWeight: 600,
		color: "#969392",
		paddingLeft: "16px",
	},
	pieChartRoot: {
		// Removes the blue outline from focused Recharts pie elements
		"& .recharts-pie:focus, & .recharts-pie path:focus": {
			outline: "none",
		},
	},
}));
